// extracted by mini-css-extract-plugin
export default {"item":"Logo2_item__x8Sw+","blogu":"Logo2_blogu__lJZKh"};